import axios from "axios";
import Api from "./../Api";

const Service = {
  async login(email, password) {
    try {
      const data = {
        "USERNAME": email,
        "PASSWORD": password
      }

        const response = await axios.post(
        `${Api}/api/ADMIN_LOGIN`,
        JSON.stringify(data),
        {
          headers: {
            "Content-Type": "application/json"
          },
        }
      );
      if (response.status === 200) {
        localStorage.setItem("email", email);
        localStorage.setItem("password", password);
        localStorage.setItem("UserID", response.data.result.existingClient._id);
        localStorage.setItem("Token", response.data.result.token);
        return { success: true };
      }
    } catch (error) {
      return { success: false, error: error.response.data.message };
    }
  },
};

export default Service;
